<template>
  <!--授权书-->
  <div class="authorization">
    <h6 class="text-center">授权书 <a @click="downloadApplyFile" href="javascript:void (0)" class="color-success">授权书模板下载</a></h6>
    <div class="upload-file">
      <div v-if="file.fileUrl" class="file-box">
        <img :src="file.fileUrl" />
      </div>
      <input v-if="!disabledSub" @change="uploadFile" :disabled="!!file.fileUrl" type="file"/>
    </div>
    <div class="text-center btn">
      <el-button @click="queryUploadApplyFile" :disabled="disabledSub" type="danger">确定提交</el-button>
      <span style="margin-left: 8px">{{applyStatus}}</span>
    </div>
  </div>
</template>

<script>
  import {fileOperShow} from '../../assets/js/http-serve/http-methods'
  import ApplyTableController from '../../assets/js/http-serve/applyTableController'

  export default {
    data () {
      return {
        // 授权状态
        applyStatus: null,
        file: {
          fileUrl: '',
          files: null
        },
        disabledSub: false
      }
    },
    mounted() {
      this.getApplyFile()
      this.getApplyStatus()
    },
    methods: {
      // 确认上传授权书
      queryUploadApplyFile() {
        ApplyTableController.applyFile(this.file.files)
          .then(() => {
            this.getApplyFile()
            this.$message.success('授权书上传成功')
          })
          .catch(err => {
            this.$message.warning(err.description || '授权书上传失败')
          })
      },
      // 获取授权申请书
      getApplyFile() {
        ApplyTableController.applyTable()
          .then(({data}) => {
            this.file.fileUrl = fileOperShow(data.applyTable)
            if (data.approveStatus === 0){
              this.applyStatus = '待审核'
            } else if (data.approveStatus === 1) {
              this.disabledSub = true
              this.applyStatus = '审核通过'
            } else if (data.approveStatus === 2) {
              this.applyStatus = '审核不通过'
            } else {
              this.applyStatus = '未上传授权书'
            }
          })
          .catch(err => {
            this.applyStatus = ''
            console.log(err)
          })
      },
      // 授权书审核状态
      getApplyStatus() {
        ApplyTableController.approveStatus()
          .then(() => {
            this.applyStatus = '正在审核'
          })
          .catch(() => {
            this.applyStatus = '未通过'
          })
      },
      // 下载授权书模板
      downloadApplyFile() {
        ApplyTableController.applyFile()
      },
      // 上传授权书
      uploadFile: function (e) {
        if (!!this.file.fileUrl) {
          return
        }

        e = e.target
        this.file.files = e.files[0]
        this.file.fileUrl = window.URL.createObjectURL(e.files[0]) || e.value;
        e.value = ''
      }
    },
    name: "authorization"
  }
</script>

<style lang="less" scoped>
  .upload-file {
    position: relative;
    background: url("/images/icon/tem_up.jpg") no-repeat;
    background-size: contain;
    background-position: center center;
    width: 240px;
    height: 280px;
    margin: 40px auto;
    border: 1px dashed #cccccc;
    overflow: hidden;

    input {
      position: absolute;
      display: block;
      width: 300%;
      height: 300%;
      top: -100px;
      left: -100px;
      background: #ffffff;
      opacity: 0;
      cursor: pointer;
    }

    .file-box {
      width: 240px;
      height: 280px;
      line-height: 280px;
      text-align: center;
      img {
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .authorization {
    padding: 40px 20px;
    border: 1px solid #efefef;

    h6 {
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/signSettings/authorization.vue